import { Component, Input, OnInit } from '@angular/core';
import { DynamicFormDto, TicketButtonDto, TicketDto, TicketQuestionnaireDto, TicketSectionDto, TicketUploadPayload } from '../../../../../service/dto';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormControlWrapper } from '../../../../../components/dynamic-form/dynamic-form-abstract';
import { HttpTicketService } from '../../../../../service/http-ticket.service';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
	selector: 'app-ticket-questionnaire-form',
	standalone: false,
	templateUrl: './ticket-questionnaire-form.component.html',
	styleUrl: './ticket-questionnaire-form.component.scss'
})
export class TicketQuestionnaireFormComponent implements OnInit {
	@Input() ticket!: TicketDto;
	@Input() questionnaire?: TicketQuestionnaireDto;

	progress: number = 50;
	dynamicForms?: { [key: number]: DynamicFormDto };
	masterForm!: FormGroup;
	allForms: FormGroup[] = [];
	allFormControls: FormControlWrapper[] = [];

	constructor(private fb: FormBuilder, private httpService: HttpTicketService, private modalRef: NzModalRef) { }

	ngOnInit(): void {
		if (!this.questionnaire) {
			this.questionnaire = {
				id: -1,
				createdAt: new Date(),
				lastActionedAt: new Date(),
				name: '',
				step: JSON.parse(JSON.stringify(this.ticket.questionnaireTemplate)),
				progress: 0,
				hashCode: 0
			}
		}
		this.masterForm = this.fb.group({});

		const activeStep = this.ticket.steps.filter(item => item.isCurrentState)[0];
		this.dynamicForms = {};
		this.allForms = [];
		this.allFormControls = [];

		this.questionnaire.step.sections = this.questionnaire.step.sections.sort((i1, i2) => i1.order - i2.order);
		this.questionnaire.step.sections.forEach(section => {
			section.elements = section.elements.sort((i1, i2) => i1.order - i2.order);
		});

		this.questionnaire.step.sections = this.questionnaire.step.sections.sort((i1, i2) => i1.order - i2.order);
		this.questionnaire.step.sections.forEach(section => {
			this.dynamicForms![section.id] = this.convertToDynamicForm(section);
		});
	}


	private convertToDynamicForm(input: TicketSectionDto): DynamicFormDto {
		const elements = input.elements.map(item => {
			return {
				id: item.id,
				value: item.value,
				property: '_' + item.id,
				dependencyId: item.dependencyId,
				name: item.label,
				description: item.description,
				sectionName: input.label,
				dependencyValue: item.dependencyValue,
				dependencyValueInverted: false,
				dataType: item.dataType,
				options: item.options,
				orderIndex: item.order,
				icon: item.icon,
				activeOnCreate: true,
				activeOnUpdate: true,
				required: item.required,
				hidden: item.hidden,
				errorMessageRequired: item.errorMessageRequired,
				isUnique: item.isUnique,
				errorMessageUnique: item.errorMessageUnique,
				regex: item.regex,
				errorMessageRegex: item.errorMessageRegex,
				minValue: item.minValue,
				errorMessageMinValue: item.errorMessageMinValue,
				maxValue: item.maxValue,
				errorMessageMaxValue: item.errorMessageMaxValue,
				hashCode: 0
			};
		});

		return {
			id: undefined,
			templateName: 'card',
			elements: elements,
			entityType: 'Member',
			subForms: {},
			hashCode: 0
		};
	}

	private getPostBody(): TicketUploadPayload {
		const out: TicketUploadPayload = {
			button: undefined as any as TicketButtonDto,
			additionalFiles: {},
			fieldProperties: {},
			requiredCommunications: {},
			additionalCommunications: []
		};
		this.allForms.forEach(form => {
			Object.keys(form.controls).forEach(key => {
				out.fieldProperties[+(key.substring(2))] = form.get(key)!.value;
			})
		})
		// this.questionnaire!.step.sections.map(item => item.elements).flat().forEach(item => {
		// 	out.fieldProperties[item.id] = item.value;
		// })
		// Object.keys(this.additionalFilesForm.controls).forEach(key => {
		// 	out.additionalFiles[key] = this.additionalFilesForm.get(key)?.value;
		// });
		// if (button) {
		// 	button.requiredCommunications.forEach(item => {
		// 		out.requiredCommunications[item.id] = JSON.parse(JSON.stringify(item));
		// 	});
		// 	out.additionalCommunications = JSON.parse(JSON.stringify(button.additionalCommunications ?? []));
		// }
		// Object.keys(out.requiredCommunications).forEach(key => {
		// 	const requiredCommunication = out.requiredCommunications[+key];
		// 	requiredCommunication.attachments = requiredCommunication.attachments?.filter(item => item.selected == true);
		// })
		// Object.keys(out.additionalCommunications).forEach(key => {
		// 	const additionalCommunication = out.additionalCommunications[+key];
		// 	additionalCommunication.attachments = additionalCommunication.attachments?.filter(item => item.selected == true);
		// })
		return out;
	}


	save() {
		if (this.questionnaire!.id <= 0) {
			this.httpService.addNewQuestionnaire(this.ticket.id, this.questionnaire!, this.getPostBody()).subscribe(result => {
				this.ticket.questionnaires.push(result);
				this.modalRef.close();
			});
		} else {
			this.httpService.updateQuestionnaire(this.ticket.id, this.questionnaire!, this.getPostBody()).subscribe(result => {
				const index = this.ticket.questionnaires.findIndex(q => q.id === result.id);
				console.log(`Replacing questionnaire at pos: ${index}`, result)
				if (index !== -1) {
					this.ticket.questionnaires[index] = result;
				}
				this.modalRef.close();
			});
		}
	}
	cancel() {
		this.modalRef.close();
	}


}
